<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="2">
                    <v-text-field class='text-body-2' v-model="pedido" label="N° Pedido" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-btn @click="verPedido()" class="mt-1" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                </v-col>
                <v-col cols="3">
                    <v-alert class='text-body-2' shaped dense text type="info">
                        Ingrese N° pedido !!!
                    </v-alert>
                </v-col>
                <v-col cols="2">
                    <v-text-field v-model="txt_portal" label="Portal" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field v-model="fecha_pedido" label="Fecha Pedido" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="2" class="text-end">
                    <v-text-field v-model="fecha" label="Fecha Hoy" outlined dense rounded disabled></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="8">
                    <v-data-table height="150px" dense
                        :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" 
                        hide-default-footer class="elevation-1 text-size col-color" @page-count="pageCount = $event">
                        <template v-slot:item.producto="{ item }">
                            {{ item.producto }} - {{ item.variante }}
                        </template>
                        <template v-slot:item.asignar="{ item }">
                            <v-edit-dialog @save="AsignarValor(item,valor_asignado)" @cancel="cancel()" @close="close()" @open="open()">
                                <span class="ml-1">{{item.asignar}}</span>
                                <template v-slot:input>
                                    <div class="mt-4 text-h6">Cantidad Devuelta</div>
                                    <v-text-field @keypress="onlyDecimal" v-model="valor_asignado" single-line clearable></v-text-field>
                                </template>
                                <v-icon small class="ml-1 blue--text">edit</v-icon>
                            </v-edit-dialog>
                        </template>                        
                        <template v-slot:item.accion="{ item }">
                            <v-icon color="red" small @click="deleteLine(item)">delete</v-icon>
                        </template>
                    </v-data-table>
                </v-col>
                <v-col cols="4">
                    <v-row class="mt-n5">
                        <v-col cols="6">
                            <h5 class="mt-3">Totales</h5>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n2">
                        <v-col cols="4">
                        <h5>Neto</h5>
                        </v-col>
                        <v-col cols="4" class="text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(neto)}}</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6">
                        <h5>Descuento ({{ porciento }}%)</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(descuento)}}</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6">
                        <h5>Afecto</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(afecto)}}</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6">
                        <h5>Iva ({{impuesto}}%)</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(iva)}}</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6">
                        <h5>Total</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>$</h5>
                        </v-col>
                        <v-col cols="4" class="mt-n6 text-end">
                        <h5>{{new Intl.NumberFormat('de-DE').format(total)}}</h5>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-alert class='text-body-2' shaped dense text type="success">
                Deje solo producto(s) con la cantidad que necesita devolver !!!
            </v-alert>
            <v-row>
                <v-col cols="6">
                    <v-row>
                        <v-col cols="8" class="mt-2">
                            <strong>FACTURACIÓN</strong>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field class='text-body-2' v-model="dte" label="Tipo Dte" outlined dense rounded disabled></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n10">
                        <v-col cols="12">
                            <v-divider></v-divider>
                            <h5>Rut: <span class="teal--text">{{rut_factura}}</span></h5>
                            <h5>Razon Social: <span class="teal--text">{{razon_factura}}</span></h5>
                            <h5>Direccion: <span class="teal--text">{{direccion_factura}}</span></h5>
                            <h5>Comuna - Ciudad: <span class="teal--text">{{comuna_factura}} - {{ ciudad_factura }}</span></h5>
                            <h5>Email: <span class="teal--text">{{email_factura}}</span></h5>
                        </v-col>
                    </v-row>
                </v-col>
                <v-divider inset vertical></v-divider>
                <v-col cols="6">
                    <v-row>
                        <v-col cols="4" class="mt-2">
                            <strong>DESPACHO</strong>
                        </v-col>
                        <v-col cols="4">
                            <h5>Peso (kg): <span class="teal--text">{{peso_despacho}}</span></h5>
                            <h5>Volumen (cm3): <span class="teal--text">{{volumen_despacho}}</span></h5>
                        </v-col>
                        <v-col cols="4" class="text-end">
                            <v-text-field class='text-body-2' v-model="transporte" label="Transporte" outlined dense rounded disabled></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n10">
                        <v-col cols="12">
                            <v-divider></v-divider>
                            <h5>Contacto: <span class="teal--text">{{contacto_despacho}}</span></h5>
                            <h5>Direccion: <span class="teal--text">{{direccion_despacho}}</span></h5>
                            <h5>Comuna - Ciudad: <span class="teal--text">{{comuna_despacho}} - {{ ciudad_despacho }}</span></h5>
                            <h5>Email: <span class="teal--text">{{email_despacho}}</span></h5>
                            <h5>Costo ($): <span class="teal--text">{{costo_despacho}}</span></h5>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" >
                    <v-text-field label="Observacion" class='text-body-2' v-model="observa" dense outlined rounded></v-text-field>
                </v-col>
                <v-col cols="2" ></v-col>
                <v-col cols="2" class="mt-1">
                    <v-btn @click="clsInput()" color="teal" small dark rounded block><span class="text-body-2">Nuevo</span></v-btn>
                </v-col>
                <v-col cols="2" class="mt-1">
                    <v-btn v-if="btn_grabado==true" @click="saveDevolucion()" color="teal" small dark rounded block><span class="text-body-2">Grabar</span></v-btn>
                    <v-btn v-else color="grey" small dark rounded block><span class="text-body-2">Grabar</span></v-btn>
                </v-col>
                <v-col cols="2" class="mt-1 text-center">
                    <v-btn v-if="btn_grabado==false" color="teal" small dark rounded block><span class="text-body-2">Enviar</span></v-btn>
                    <v-btn v-else color="grey" small dark rounded block><span class="text-body-2">Enviar</span></v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>

    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Devoluciones',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    pedido:'',
    fecha_pedido:'',
    hoy:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    fecha:'',
    headers: [
      { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
      { text: 'Producto - Variante', align: 'start', sortable: true, value: 'producto' },
      { text: 'Precio', align: 'center', sortable: true, value: 'precio' },
      { text: 'Cantidad', align: 'center', sortable: false, value: 'cantidad' },
      { text: 'Total', align: 'start', sortable: false, value: 'total' },
      { text: 'Devolucion',align: 'center',sortable: false, value: 'asignar'},
      { text: '', align: 'start', sortable: false, value: 'accion' },
    ],
    items: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 1000000,

    peso:'',
    volumen:'',

    neto:0,
    porciento:0,
    descuento:0,
    impuesto:'19',
    iva:0,
    afecto:0,
    total:0,
    observa:'',
    dte:'',
    transporte:'',

    pais:'Chile',

    //formulario factura
    rut_factura:'',
    razon_factura:'',
    giro_factura:'',
    email_factura:'',
    fono_factura:'',
    region_factura:'',
    direccion_factura:'',
    comuna_factura:'',
    ciudad_factura:'',

    //formulario despacho
    contacto_despacho:'',
    email_despacho:'',
    fono_despacho:'',
    region_despacho:'',
    direccion_despacho:'',
    comuna_despacho:'',
    ciudad_despacho:'',
    costo_despacho:0,
    peso_despacho:'',
    volumen_despacho:'',

    numClicks:0,
    portal:0,
    txt_portal:'',
    btn_grabado:true,

    valor_asignado:0,
    filled:false,
    disabled:false,
    bloqueo:null,
    loading:false,

  }),
  async mounted(){
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    this.fecha=this.formatFecha(this.hoy);
    this.bloqueo = await this.myPermiso(6);
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    clsInput(){
        this.pedido='';
        this.filled=false;
        this.disabled=false;
        this.valor_asignado=0;
        this.fecha_pedido='';
        this.items=[];
        this.peso='';
        this.volumen='';
        this.neto=0;
        this.porciento=0;
        this.descuento=0;
        this.iva=0;
        this.afecto=0;
        this.total=0;
        this.observa='';
        this.dte='',
        this.transporte='',
        //formulario factura
        this.rut_factura='';
        this.razon_factura='';
        this.giro_factura='';
        this.email_factura='';
        this.fono_factura='';
        this.region_factura='';
        this.direccion_factura='';
        this.comuna_factura='';
        this.ciudad_factura='';
        //formulario despacho
        this.contacto_despacho='';
        this.email_despacho='';
        this.fono_despacho='';
        this.region_despacho='';
        this.direccion_despacho='';
        this.comuna_despacho='';
        this.ciudad_despacho='';
        this.costo_despacho=0;
        this.peso_despacho='';
        this.volumen_despacho='';
        this.numClicks=0;
        this.portal='';
        this.txt_portal='';
        this.btn_grabado=true;
    },
    formatFecha(fec){
      const dia = fec.substring(8,10);
      const mes = fec.substring(5,7);
      const anio = fec.substring(0,4);
      const hoy = dia + '-' + mes + '-' + anio;
      return hoy;
    },
    onlyDecimal ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    AsignarValor(item, valor){
        if(valor!=null){
            if(parseFloat(valor)!=0){
                if(parseFloat(valor)<=parseFloat(item.vcantidad)){
                    item.asignar=valor;
                }
            }
        }
        this.valor_asignado=0;
        this.calcularPedido();
    },
    cancel() {
        console.log('cancel');
    },
    open() {
        console.log('open');
    },
    close() {
        console.log('close');
    },
    async verPedido(){
        if(this.pedido!=''){
            this.loading=true;
            try {
                let res;
                let datos;
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    order :  this.pedido
                };
                //orden
                res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/order_ecommerce/',params,{headers});
                datos = res.data;
                if(datos[0].existe=='si'){
                    this.filled=true;
                    this.disabled=true;
                    const data_order = datos[0];
                    this.portal = data_order.portal;
                    this.txt_portal = await this.searchPortal(data_order.portal);
                    this.fecha_pedido=this.formatFecha(data_order.fecha);                    
                    // this.neto=data_order.neto;
                    this.impuesto=data_order.impuesto;
                    this.porciento=data_order.porciento;
                    // this.descuento=data_order.descuento;
                    // this.iva=data_order.iva;
                    // this.afecto=data_order.afecto;
                    // this.total=data_order.total;

                    //detalle devoluciones
                    let array_dev = [];
                    res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/detail_devolutions/',params,{headers});
                    datos = res.data;
                    if(datos[0].existe=='si'){
                        array_dev = datos;
                    };
                    //productos
                    res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products_ecommerce/',params,{headers});
                    datos = res.data;
                    if(datos[0].existe=='si'){
                        let var_peso = 0;
                        let var_volumen = 0;
                        datos.forEach(element => {
                            var_peso = parseFloat(parseFloat(var_peso) + parseFloat(element.peso)).toFixed(2);
                            var_volumen = parseFloat(parseFloat(var_volumen) + parseFloat(element.volumen)).toFixed(2);
                            //validamos si existe devolucion del sku
                            const filter_dev = array_dev.filter(res => res.sku == element.sku);
                            let cantidad_dev = 0;
                            if(filter_dev.length!=0){
                                filter_dev.forEach(e => {
                                    cantidad_dev = parseFloat(cantidad_dev) + parseFloat(e.cantidad);                             
                                });
                            };
                            const var_saldo = parseFloat(element.cantidad) - parseFloat(cantidad_dev);
                            const var_total = parseFloat(parseFloat(element.precio) * parseFloat(element.cantidad)).toFixed(2);
                            if(parseFloat(var_saldo)!=0){
                                this.items.push({
                                    sku: element.sku,
                                    producto: element.producto,
                                    variante: element.variante,
                                    precio: new Intl.NumberFormat('de-DE').format(element.precio),
                                    vprecio: element.precio,
                                    cantidad: new Intl.NumberFormat('de-DE').format(var_saldo),
                                    vcantidad: var_saldo,
                                    total: new Intl.NumberFormat('de-DE').format(var_total),
                                    vtotal: var_total,
                                    peso: element.peso,
                                    volumen: element.volumen,
                                    asignar: var_saldo,
                                })                                    
                            }
                        });
                        this.peso = var_peso;
                        this.volumen = var_volumen
                    };
                    this.calcularPedido();
                    //facturacion
                    res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/invoice_ecommerce/',params,{headers});
                    datos = res.data;
                    if(datos[0].existe=='si'){
                        const data_invoice = datos[0];
                        this.rut_factura=data_invoice.rut;
                        this.razon_factura=data_invoice.razon;
                        this.giro_factura=data_invoice.giro;
                        this.email_factura=data_invoice.email;
                        this.fono_factura=data_invoice.fono;
                        this.region_factura=data_invoice.region;
                        this.direccion_factura=data_invoice.direccion;
                        this.comuna_factura=data_invoice.comuna;
                        this.ciudad_factura=data_invoice.ciudad;
                        this.dte = data_invoice.dte;
                    };
                    //despacho
                    res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/shipping_ecommerce/',params,{headers});
                    datos = res.data;
                    if(datos[0].existe=='si'){
                        const data_shipping = datos[0];
                        this.contacto_despacho=data_shipping.nombre;
                        this.email_despacho=data_shipping.email;
                        this.fono_despacho=data_shipping.fono;
                        this.region_despacho=data_shipping.region;
                        this.direccion_despacho=data_shipping.direccion;
                        this.comuna_despacho=data_shipping.comuna;
                        this.ciudad_despacho=data_shipping.ciudad;
                        this.costo_despacho=data_shipping.costo;
                        this.peso_despacho=data_shipping.peso;
                        this.volumen_despacho=data_shipping.volumen;
                        this.transporte = data_shipping.transporte;
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='El pedido ingresado no existe';
                    this.snack=true                    
                }
            } catch (error) {
                console.log(error);
                this.color_snack='error';
                this.mensaje='Algo salio mal, intetelo mas tarde';
                this.snack=true
            }
            this.loading=false;
        } else {
            this.color_snack='error';
            this.mensaje='Ingrese numero de Pedido';
            this.snack=true
        }
    },
    async searchPortal(number){
        let result = '';
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                portal :  number
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/portals/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = datos[0].name;
            }
        } catch (error) {
            console.log(error);
        };
        return result
    },
    calcularPedido(){
        //reestablecer variables,
        this.neto = 0;
        this.descuento = 0;
        this.afecto = 0;
        this.iva = 0;
        this.total = 0;
        this.peso_despacho = '';
        this.volumen_despacho = '';
        if(this.items.length!=0){
            //sumamos el neto
            let subtotal = 0;
            let suma_peso = 0;
            let suma_volumen = 0;
            this.items.forEach(element => {
                subtotal = parseFloat(parseFloat(subtotal) + (parseFloat(element.vprecio)*parseFloat(element.asignar))).toFixed(0);
                suma_peso = parseFloat(suma_peso) + (parseFloat(element.peso) * parseFloat(element.asignar));
                suma_volumen = parseFloat(suma_volumen) + (parseFloat(element.volumen) * parseFloat(element.asignar));
            });
            const v_neto = parseFloat(subtotal);
            const v_descuento = parseFloat((parseFloat(subtotal) * parseFloat(this.porciento))/100).toFixed(0);
            const v_afecto = parseFloat(v_neto) - parseFloat(v_descuento);
            const v_iva = parseFloat((parseFloat(v_afecto) * parseFloat(this.impuesto))/100).toFixed(0);
            const v_total = parseFloat(v_afecto) + parseFloat(v_iva);

            this.neto = v_neto;
            this.descuento = v_descuento;
            this.afecto = v_afecto;
            this.iva = v_iva;
            this.total = v_total;
            this.peso_despacho = parseFloat(suma_peso).toFixed(2);
            this.volumen_despacho = parseFloat(suma_volumen).toFixed(2);
        }
    },
    async deleteLine(fila){
        this.items = this.items.filter(function(dat) {
            return dat.sku !== fila.sku; 
        });
        this.calcularPedido()
    },
    async saveDevolucion(){
        this.loading=true;
        if(this.items.length!=0){
            //preparamos el params
            const array_order = {
                orden: this.pedido,
                portal: this.portal,
                fecha: this.hoy,
                neto: this.neto,
                porciento: this.porciento,
                descuento: this.descuento,
                afecto: this.afecto,
                impuesto: this.impuesto,
                iva: this.iva,
                total: this.total,
                observa: this.observa
            };
            const array_data ={
                totales: array_order,
                detalle: this.items
            };
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    data :  array_data
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/devolution/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    this.color_snack='success';
                    this.mensaje='Devolucion ingreasada con exito';
                    this.snack=true
                    this.btn_grabado=false;
                } else {
                    this.color_snack='error';
                    this.mensaje='La devolucion no fue ingresada, intentelo mas tarde';
                    this.snack=true
                }
            } catch (error) {
                console.log(error)                
                this.color_snack='error';
                this.mensaje='Algo salio mal, intentelo mas tarde';
                this.snack=true
            }
        } else {
            this.color_snack='error';
            this.mensaje='No existen productos para devolucion';
            this.snack=true
        }
        this.loading=false;
    },

  }
}
</script>
